import type * as React from 'react';

import type * as api from '@gitbook/api-client';
import { Badge, type BadgeProps, Tooltip } from '@gitbook/spine-react';

import {
    ChangeRequestStatusIcon,
    getChangeChangeRequestStatusDescriptor,
} from './ChangeRequestStatus';

/**
 * Badge to represent the status of a change request.
 */
export function ChangeRequestStatusBadge(
    props: {
        status: api.ChangeRequestStatus;
        withIcon?: boolean;
    } & Omit<BadgeProps, 'icon' | 'label' | 'kind'>
): React.ReactElement {
    const { status, withIcon = true, ...rest } = props;
    const descriptor = getChangeChangeRequestStatusDescriptor(status);

    return (
        <Tooltip label={descriptor.description}>
            <Badge
                {...rest}
                kind={descriptor.kind}
                label={descriptor.label}
                icon={withIcon ? <ChangeRequestStatusIcon status={status} /> : undefined}
            />
        </Tooltip>
    );
}
